import { siteConfig } from '../../site.config';

export interface AuthorLinkProps {
  className?: string;
}

/**
 * Renders the site author's name as an external link to
 * siteConfig.author.url, falling back to plain text when no URL is set.
 */
export function AuthorLink({ className }: AuthorLinkProps) {
  if (!siteConfig.author.url) return <>{siteConfig.author.name}</>;
  return (
    <a
      href={siteConfig.author.url}
      target="_blank"
      rel="noopener noreferrer"
      className={className ?? 'text-accent hover:underline'}
    >
      {siteConfig.author.name}
    </a>
  );
}

export default AuthorLink;
